import React, { useState } from "react";
import useSize from "../../../Utils/useSize/useSize";
import Header from "./Header/Header";
import Create from "./Create/Create";
import Summary from "./Summary/Summary";
import UserList from "./UserList/UserList";

export default function User() {
  const windowSize = useSize();

  const userType = Number(localStorage.getItem("user_type") || 7);

  const [master_id, setMasterId] = useState(null);

  const [type, setType] = useState(2);

  return (
    <div
      style={{
        height: windowSize[1] - 100,
      }}
    >
      <Header
        type={type}
        updateType={(a) => setType(a)}
        master={(m) => {
          setMasterId(m);
        }}
        userType={userType}
      />

      {type === 0 ? <Create master_id={master_id} userType={userType} /> : null}
      {type === 1 ? <Summary master_id={master_id} userType={userType} /> : null}
      {type === 2 ? <UserList master_id={master_id} userType={userType} /> : null}
    </div>
  );
}
